export default function(obj, key) {
  return obj[key] !== undefined && key in obj && obj[key] !== ''
}
